import { CalendarBlankIcon } from '@phosphor-icons/react';
import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@skupreme/shared/ui';
import { FIELD_INPUT } from '@elements/form-field/styles';

/** The text box react-datepicker opens its calendar from; it clones this with its own handlers. */
export const CalendarInput = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement>
>(({ className, ...rest }, ref) => (
  <span className="sk:relative sk:flex sk:w-full sk:items-center">
    <input
      {...rest}
      ref={ref}
      className={cn(FIELD_INPUT, 'sk:pr-8!', className, 'sk:m-0!')}
    />
    <CalendarBlankIcon
      size={14}
      aria-hidden
      className="sk:pointer-events-none sk:absolute sk:right-3 sk:text-fg-tertiary"
    />
  </span>
));
CalendarInput.displayName = 'CalendarInput';
